import { Pipe, PipeTransform } from '@angular/core';
import { GalleryCover } from '@nusign/picflow-backend-types';

@Pipe({
  name: 'coverToVideoData',
  standalone: true,
})
export class CoverToVideoDataPipe implements PipeTransform {
  transform(galleryCover: GalleryCover, video_origin: string) {
    const params = new URLSearchParams(video_origin.split('?')[1]);
    return {
      width: galleryCover.width,
      height: galleryCover.height,
      duration: Number(params.get('duration') || 0),
    };
  }
}
